/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class s{}const c=s,e=new c;export{c as NoParameters,e as noParameters};
